import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { loadConfig } from './api/config';
import { assigneeWords } from './st8n-tickets/marks.jsx';
import { applyTheme, type Theme } from './theme';
import { watchForUpdates } from './ui/shell';
import './st8n-tickets/tickets.css';
import './styles.css';

// The theme: ?theme= (for screenshots), else the person's choice, else the device's.
let theme: Theme = 'system';
try {
  theme = JSON.parse(localStorage.getItem('deleg8.theme') ?? '"system"') as Theme;
} catch {
  /* the device's */
}
const asked = new URLSearchParams(location.search).get('theme');
if (asked === 'light' || asked === 'dark') theme = asked;
applyTheme(theme);

/** The home-screen name: a portal host is named for its company (config.brandName); iOS reads these tags when the icon is added. */
function nameTheApp(name?: string) {
  if (!name) return;
  for (const sel of ['meta[name="apple-mobile-web-app-title"]', 'meta[name="application-name"]']) document.querySelector(sel)?.setAttribute('content', name);
}

/** One service worker keeps the app shell for an installed app; it never keeps API answers (public/sw.js). Not in dev.
 *  A new version taking over says so (ui/shell.tsx: "A new version is ready", Reload). */
function keepTheShell() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const go = () => { navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((reg) => watchForUpdates(navigator.serviceWorker, reg), () => {}); };
  if (document.readyState === 'complete') go();
  else addEventListener('load', go, { once: true });
}

void loadConfig().then((c) => {
  if (c.front === 'portal' && c.brandName) document.title = c.brandName;
  nameTheApp(c.brandName);
  if (!c.st8nOn) Object.assign(assigneeWords, { any: 'Anyone', person: (n: string) => n });
  keepTheShell();
  createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
});
